
// React base styles
import borders from "assets/mavric-theme/base/borders";
import boxShadows from "assets/mavric-theme/base/boxShadows";
import colors from "assets/mavric-theme/base/colors";

const { borderRadius } = borders;
const { xxl } = boxShadows;
const { transparent } = colors;

const dialog = {
  styleOverrides: {
    paper: {
      borderRadius: borderRadius.lg,
      boxShadow: xxl,
      backgroundColor: transparent.main,
    },

    paperFullScreen: {
      borderRadius: 0,
    },
  },
};

export default dialog;
